const delegate = function (element, event, selector, handler) {
    element.addEventListener(event, function (event) {
        let t = event.target;
        while (t && t !== this) {
            if (t.matches(selector)) {
                handler.call(t, event);
            }
            t = t.parentNode;
        }
    })
}

class CustomHarperEvents {

    constructor () {
        this.CATEGORY = 'Harper';
        this.clickEventLookup = {
            '[harper-more-info-cta]': { // 1a.
                'action': 'Find Out More - Postcode Checker Click',
                'label': 'Find Out More - Postcode Checker Click',
            },
            '.pdp-harper-cta': { // 1b.
                'action': 'Find Out More - Product Page Click',
                'label': 'Find Out More - Product Page Click',
            },
            '#cart-icon-bubble': { // 3a.
                'action': 'Bag Click',
                'label': 'Bag Click',
            },
            '#harper_checkout a[href*="checkout"]': { // 3b.
                'action': 'Checkout Click',
                'label': 'Checkout Click',
            },
            '#harper_try_at_home_button': { // 3c
                'action': 'CTA - Bag Click',
                'label': '',
                'callback': (label, ev, cartState) => {
                    return Shopify.formatMoney(cartState.total_price);
                }
            }
        };
        this.loadEventLookup = {
            'pages/harper-concierge-service': { // 1c.
                'action': 'Landing Page',
                'label': 'Landing Page',
            }
        };
        this.bindEventListeners();
    }

    bindEventListeners () {
        // click events
        const selectors = Object.keys(this.clickEventLookup);
        selectors.forEach(selector => {
            delegate(document, 'click', selector, (ev) => {
                ev.preventDefault();
                this.fireEvent(this.clickEventLookup[selector], ev, () => {
                    // don't want to prevent anchor navigation
                    if (ev.target.nodeName === 'A') {
                        const href = ev.target.getAttribute('href');
                        if (href && href !== '') {
                            window.location = href;
                        }
                    }
                });
            });
        });

        // page load events
        Object.keys(this.loadEventLookup).forEach(url => {
            if (window.location.pathname.match(url)) {
                this.fireEvent(this.loadEventLookup[url]);
            }
        });

        // other events
        delegate(document, 'click', '#harper_continue_button', (ev) => { // 2a.
            ev.preventDefault();
            const errorMessage = document.querySelector('#harper-error');
            if (errorMessage) {
                errorMessage.textContent = '';
            }
            const postcode = document.querySelector('#harper-send-to-parent-form #postcode').value;
            if (postcode !== '') {
                this.fireEvent({
                    'action': 'Postcode Search',
                    'label': postcode,
                });
            }
        });
        document.addEventListener("DOMContentLoaded", () => { // 2b.
            let intervalCount = 0;
            let interval = setInterval(() => {
                if (document.getElementById('harper-error')) {
                    clearInterval(interval);

                    const postcodeErrorElement = document.getElementById('harper-error');
                    const observerConfig = {
                        childList: true,
                    };
                    const observerCallback = (mutationList, observer) => {
                        for (const mutation of mutationList) {
                            if (mutation.type === 'childList' && postcodeErrorElement.textContent !== '') {
                                this.fireEvent({
                                    'action': 'Postcode Search Error',
                                    'label': document.querySelector('#harper-send-to-parent-form #postcode').value,
                                });
                            }
                        }
                    };
                    const observer = new MutationObserver(observerCallback);
                    observer.observe(postcodeErrorElement, observerConfig);
                }
                intervalCount++;

                if (intervalCount > 15) {
                    clearInterval(interval);
                }
            }, 1000);
        });
    }

    async getCartState () {
        const response = await fetch('/cart.json');
        const cart = await response.json();
        
        return cart;
    }

    async fireEvent (lookup, ev, afterCallback) {
        let {action, label, callback} = lookup;
        const cartState = await this.getCartState();

        if (typeof callback !== 'undefined') {
            label = callback(label, ev, cartState);
        }

        gtag('event', action, {
            'event_category': this.CATEGORY,
            'event_label': label,
        });

        if (typeof afterCallback !== 'undefined') {
            afterCallback();
        }
    }

}

window.customHarperEvents = new CustomHarperEvents();
